import Container from '../../../../components/Container'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'
import { FormInstitution } from '../components/Form'

const InstitutionCreate = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormInstitution typeForm="create" />
  </Container>
)

export default InstitutionCreate
